"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPERATORS = void 0;
exports.isGuardFailure = isGuardFailure;
exports.isGuardSuccess = isGuardSuccess;
exports.OPERATORS = [
    '$contains',
    '$starts',
    '$ends',
    '$eq',
    '$ne',
    '$in',
    '$notIn',
    '$gt',
    '$gte',
    '$lt',
    '$lte',
    '$notNull',
    '$isNull'
];
function isGuardFailure(result) {
    return result.allowed === false;
}
function isGuardSuccess(result) {
    return result.allowed === true;
}
